// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___nqOh","badges":"styles_badges__1-aMK"};